module.exports = __webpack_public_path__ + "img/legendElevatedWard.76935ea7.svg";